import { wrapGql } from "../_"

export default (a: NuxtAxiosInstance) => ({
  getStatuses: () => wrapGql(
    a.$post("/graphql", {
      query: /* gql */ `
        query {
          listStatus(limit: 999) {
            items {
              id
              title {
                current
              }
              default
            }
          }
        }
      `,
    }),
    "listStatus",
  ),

  findStatus: (id: string, cfg?: AxiosConfig) => wrapGql(
    a.$post("/graphql", {
      query: /* gql */ `
        query($id: UUID!) {
          findStatus(id: $id) {
            title {
              current
            }
          }
        }
      `,
      variables: { id },
    }, cfg),
  ),

  getEventData: (cfg?: AxiosConfig) => wrapGql(
    a.$post("/graphql", {
      query: /* gql */ `
        query {
          currentEvent {
            alias
            id
            visibility
            title { current }
            description { current }
            start
            finish
            logo { url }
            logoEn { url }
            banner { url }
            bannerEn { url }
            metadata {
              favicon { url }
              image { url }
              metrics {
                googleTagManager
                facebookPixel
                yandexMetrika
              }
            }
            links {
              vkontakte
              telegram
              odnoklassniki
              max
            }
            country {
              title { current }
            }
            region {
              title { current }
            }
            place { current }
            minBirthdate
            maxBirthdate
            minAge
            maxAge
            registrationStart
            registrationFinish
            organizer
            website
            contest {
              start
              finish
            }
            participating
            participationState
            allowedCategories
            features
            type
            statuses {
              default
              allowedCategories
              minBirthdate
              maxBirthdate
              id
              alias
            }
            parseDocuments
          }
        }
      `,
    }, cfg),
    "currentEvent",
  ),

  getMenu: () => wrapGql(
    a.$post("/graphql", {
      query: /* gql */ `
        query {
          listMenuItem {
            items {
              title {
                current
              }
              url
              newTab
            }
          }
        }
      `,
    }),
    "listMenuItem",
  ),

  listEvent: (page: number, filters?: any, limit?: number) => wrapGql(
    a.$post("/graphql", {
      query: /* gql */ `
        query (
          $page: Int!
          $filters: [Filter]
          $limit: Int
        ) {
          listEvent (
            page: $page
            filters: $filters
            limit: $limit
            sorters: [{ name: "start", order: ASC }]
          ) {
            items {
              id
              alias
              start
              finish
              minBirthdate
              maxBirthdate
              registrationStart
              registrationFinish
              title { current }
              description { current }
              logo { url }
              logoEn { url }
              region {
                id
                title {
                  current
                }
              }
              contest {
                start
                finish
              }
              participating
              participationState
              allowedCategories
              features
              country {
                id
                title { current }
              }
              status { alias }
              registrationFinish
              type
              statuses {
                default
                allowedCategories
                minBirthdate
                maxBirthdate
                id
              }
              organizer
            }
            pagination {
              pages
            }
          }
        }
      `,

      variables: {
        page,
        filters,
        limit,
      },
    }),
    "listEvent",
  ),

  listMyEvent: (page: number, filters?: Record<string, string>[]) => wrapGql(
    a.$post("/graphql", {
      query: /* gql */ `
        query (
          $page: Int!
          $filters: [Filter]
        ) {
          listMyEvent (
            page: $page
            sorters: [{ name: "start", order: ASC }]
            filters: $filters
          ) {
            items {
              id
              alias
              start
              finish
              minBirthdate
              maxBirthdate
              registrationFinish
              title {
                current
              }
              logo {
                url
              }
              logoEn { url }
              region {
                title {
                  current
                }
              }
              contest {
                start
                finish
              }
              participating
              participationState
              allowedCategories
              features
              registrationFinish
              type
            }
            pagination {
              pages
            }
          }
        }
      `,

      variables: {
        page,
        filters,
      },
    }),
  ),

  listMyContestEvent: (page: number) => wrapGql(
    a.$post("/graphql", {
      query: /* gql */ `
        query (
          $page: Int!
        ) {
          listMyContestEvent (
            page: $page
            sorters: [{ name: "start", order: ASC }]
          ) {
            items {
              id
              alias
              start
              finish
              minBirthdate
              maxBirthdate
              registrationFinish
              title {
                current
              }
              logo {
                url
              }
              logoEn { url }
              region {
                title {
                  current
                }
              }
              contest {
                start
                finish
              }
              participating
              type
            }
            pagination {
              pages
            }
          }
        }
      `,

      variables: {
        page,
      },
    }),
  ),

  sendFeedback: (variables: Record<string, any>) => wrapGql(
    a.$post("/graphql", {
      query: /* gql */ `
        mutation (
          $email: String
          $name: String
          $text: String
          $consent: Boolean
          $captcha: String
        ) {
          sendFeedback (
            email: $email
            name: $name
            text: $text
            consent: $consent
            captcha: $captcha
          )
        }
      `,

      variables,
    }),
  ),
})
